// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-wrapper {
  padding: 90px 0px;
}
.table-wrapper .table-container {
  margin-top: 5rem;
}

.campain-table-container .campain-title h2 {
  margin-bottom: 74px;
}
@media screen and (min-width: 1024px) {
  .campain-table-container .campain-title h2 {
    margin-bottom: 93px;
  }
}
.campain-table-container .campain-title h2 .table-filte-body button {
  width: 100%;
}
.campain-table-container .campain-title .table-container {
  margin-top: 32px;
}
@media screen and (min-width: 1024px) {
  .campain-table-container .campain-title .table-container {
    margin-top: 25px;
  }
}

.table-filter-body .form-container .field-container {
  margin: 23px 0;
}
.table-filter-body .form-container .field-container .MuiFormControl-root:first-child {
  margin-right: 24px;
}
.table-filter-body .form-container .field-container .form-control.w-50 {
  width: 50% !important;
}
.table-filter-body .form-container .field-button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.table-filter-body .form-container .field-button-container .w-50 {
  width: 100%;
}
@media screen and (min-width: 1024px) {
  .table-filter-body .form-container .field-button-container .w-50 {
    width: 50% !important;
  }
}
.table-filter-body .form-container .field-button-container .w-50 button {
  width: 100%;
  margin-top: 15px;
}
@media screen and (min-width: 1024px) {
  .table-filter-body .form-container .field-button-container .w-50 button {
    width: calc(50% - 14px);
    margin: 0 7px;
  }
}
.table-filter-body .form-container .table-filter-body .form-container .field-container {
  margin: 23px 0;
}
.table-filter-body .form-container .table-filter-body .form-container .field-container .MuiFormControl-root.form-control {
  width: 100% !important;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .table-filter-body .form-container .field-container .MuiFormControl-root.form-control {
    width: 50% !important;
  }
}
.table-filter-body .form-container .table-filter-body .form-container .field-container .MuiFormControl-root.form-control:first-child {
  margin-right: 0;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .table-filter-body .form-container .field-container .MuiFormControl-root.form-control:first-child {
    margin-right: 24px;
    width: calc(50% - 24px) !important;
  }
}
.table-filter-body .form-container .table-filter-body .form-container .field-button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.table-filter-body .form-container .table-filter-body .form-container .field-button-container .date-container {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .table-filter-body .form-container .field-button-container .date-container {
    width: calc(50% - 24px);
    margin-right: 24px;
  }
}
.table-filter-body .form-container .table-filter-body .form-container .field-button-container .date-container span {
  color: white;
  width: 100px;
  font-size: 19px;
}
.table-filter-body .form-container .table-filter-body .form-container .field-button-container .date-container .date-picker-field {
  background-color: black;
  border: none;
  border-bottom: 1px solid white;
  min-width: 240px;
  width: 100%;
  color: white;
}
.table-filter-body .form-container .table-filter-body .form-container .field-button-container .buttons {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .table-filter-body .form-container .field-button-container .buttons {
    width: 50%;
  }
}
.table-filter-body .form-container .table-filter-body .form-container .field-button-container .buttons button {
  margin: 15px 7px;
  width: 100%;
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .table-filter-body .form-container .field-button-container .buttons button {
    width: calc(33.33% - 14px);
    margin-top: 0px;
  }
}
@media screen and (min-width: 768px) {
  .table-filter-body .form-container .log-date-container {
    width: calc(50% - 24px);
    margin-right: 24px;
  }
}
.table-filter-body .form-container .log-date-container span {
  color: white;
  width: 100px;
  font-size: 19px;
}
.table-filter-body .form-container .log-date-container .date-picker-field {
  background-color: black;
  border: none;
  border-bottom: 1px solid white;
  min-width: 240px;
  width: 900px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/global-read-only-tables/login-attempts-logs/Log.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAAE;EACE,gBAAA;AAEJ;;AAGI;EACE,mBAAA;AAAN;AACM;EAFF;IAGI,mBAAA;EAEN;AACF;AAAQ;EACE,WAAA;AAEV;AAEI;EACE,gBAAA;AAAN;AACM;EAFF;IAGI,gBAAA;EAEN;AACF;;AAII;EACE,cAAA;AADN;AAEM;EACE,kBAAA;AAAR;AAGQ;EACE,qBAAA;AADV;AAKI;EACE,aAAA;EACA,eAAA;EACA,yBAAA;AAHN;AAIM;EACE,WAAA;AAFR;AAGQ;EAFF;IAGI,qBAAA;EAAR;AACF;AACQ;EACE,WAAA;EACA,gBAAA;AACV;AAAU;EAHF;IAII,uBAAA;IACA,aAAA;EAGV;AACF;AAIQ;EACE,cAAA;AAFV;AAGU;EACE,sBAAA;AADZ;AAEY;EAFF;IAGI,qBAAA;EACZ;AACF;AAAY;EACE,eAAA;AAEd;AADc;EAFF;IAGI,kBAAA;IACA,kCAAA;EAId;AACF;AAKQ;EACE,aAAA;EACA,eAAA;EACA,8BAAA;AAHV;AAKU;EACE,WAAA;AAHZ;AAIY;EAFF;IAGI,uBAAA;IACA,kBAAA;EADZ;AACF;AAEY;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAAd;AAEY;EACE,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAAd;AAGU;EACE,WAAA;AADZ;AAEY;EAFF;IAGI,UAAA;EACZ;AACF;AAAY;EACE,gBAAA;EACA,WAAA;AAEd;AADc;EAHF;IAII,0BAAA;IACA,eAAA;EAId;AACF;AAIM;EADF;IAEI,uBAAA;IACA,kBAAA;EADN;AACF;AAEM;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAAR;AAEM;EACE,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAAR","sourcesContent":[".table-wrapper {\n  padding: 90px 0px;\n  & .table-container {\n    margin-top: 5rem;\n  }\n}\n.campain-table-container {\n  .campain-title {\n    h2 {\n      margin-bottom: 74px;\n      @media screen and (min-width: 1024px) {\n        margin-bottom: 93px;\n      }\n      .table-filte-body {\n        button {\n          width: 100%;\n        }\n      }\n    }\n    .table-container {\n      margin-top: 32px;\n      @media screen and (min-width: 1024px) {\n        margin-top: 25px;\n      }\n    }\n  }\n}\n.table-filter-body {\n  .form-container {\n    .field-container {\n      margin: 23px 0;\n      .MuiFormControl-root:first-child {\n        margin-right: 24px;\n      }\n      .form-control {\n        &.w-50 {\n          width: 50% !important;\n        }\n      }\n    }\n    .field-button-container {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-end;\n      .w-50 {\n        width: 100%;\n        @media screen and (min-width: 1024px) {\n          width: 50% !important;\n        }\n        button {\n          width: 100%;\n          margin-top: 15px;\n          @media screen and (min-width: 1024px) {\n            width: calc(50% - 14px);\n            margin: 0 7px;\n          }\n        }\n      }\n    }\n\n    .table-filter-body {\n      .form-container {\n        .field-container {\n          margin: 23px 0;\n          .MuiFormControl-root.form-control {\n            width: 100% !important;\n            @media screen and (min-width: 768px) {\n              width: 50% !important;\n            }\n            &:first-child {\n              margin-right: 0;\n              @media screen and (min-width: 768px) {\n                margin-right: 24px;\n                width: calc(50% - 24px) !important;\n              }\n            }\n          }\n          // .form-control {\n          //   &.w-50 {\n          //     width: 50% !important;\n          //   }\n          // }\n        }\n        .field-button-container {\n          display: flex;\n          flex-wrap: wrap;\n          justify-content: space-between;\n          // margin-left: 8px;\n          .date-container {\n            width: 100%;\n            @media screen and (min-width: 768px) {\n              width: calc(50% - 24px);\n              margin-right: 24px;\n            }\n            span {\n              color: white;\n              width: 100px;\n              font-size: 19px;\n            }\n            .date-picker-field {\n              background-color: black;\n              border: none;\n              border-bottom: 1px solid white;\n              min-width: 240px;\n              width: 100%;\n              color: white;\n            }\n          }\n          .buttons {\n            width: 100%;\n            @media screen and (min-width: 768px) {\n              width: 50%;\n            }\n            button {\n              margin: 15px 7px;\n              width: 100%;\n              @media screen and (min-width: 768px) {\n                width: calc(33.33% - 14px);\n                margin-top: 0px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .log-date-container {\n      @media screen and (min-width: 768px) {\n        width: calc(50% - 24px);\n        margin-right: 24px;\n      }\n      span {\n        color: white;\n        width: 100px;\n        font-size: 19px;\n      }\n      .date-picker-field {\n        background-color: black;\n        border: none;\n        border-bottom: 1px solid white;\n        min-width: 240px;\n        width: 900px;\n        color: white;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
